import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { CoreConfigService } from "@core/services/config.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-language-switcher",
  templateUrl: "./language-switcher.component.html",
  styleUrls: ["./language-switcher.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class LanguageSwitcherComponent implements OnInit {
  @Input() isNotMargin = false;
  public languageOptions: any;
  public navigation: any;
  public selectedLanguage: any;
  constructor(
    public _translateService: TranslateService,
    private _coreConfigService: CoreConfigService
  ) {
    this.languageOptions = {
      vi: {
        title: "Tiếng Việt",
        flag: "vn"
      },
      en: {
        title: "English",
        flag: "us"
      }
    };
  }

  ngOnInit(): void {}

  setLanguage(language): void {
    // Set the selected language for the navbar on change
    this.selectedLanguage = language;

    // Use the selected language id for translations
    this._translateService.use(language);

    this._coreConfigService.setLanguageForLayout(language);
  }
}
